export interface MenuItem {
    basePath: string
    path: string
    description: string
    hint: string
    icon: string
    color: string
    external: boolean
    active: boolean
    isVisible: () => boolean
}

export interface MenuSection {
    key: string
    title: string|null
    pinned: boolean
    items: MenuItem[]
}

// `color` e um token de src/utils/styles/theme.scss (--menu-*): no escuro cada cor clareia
// para manter contraste sobre o menu.
function createItem(path:string, description:string, hint:string, icon:string, color:string):MenuItem {
    return {
        basePath: path,
        path,
        description,
        hint,
        icon,
        color,
        external: false,
        active: false,
        isVisible: () => true,
    }
}

export function createMenuSections():MenuSection[] {
    return [
        {
            key: 'home',
            title: null,
            pinned: false,
            items: [
                createItem('/dashboard', 'Dashboard', 'Visão geral de vendas, pedidos e desempenho da operação', 'chart-line', 'var(--menu-dashboard)'),
            ],
        },
        {
            key: 'sales',
            title: 'Vendas',
            pinned: false,
            items: [
                createItem('/pedidos', 'Pedidos', 'Acompanhe, filtre e trate os pedidos de todos os seus canais', 'truck-loading', 'var(--menu-pedidos)'),
                createItem('/formas_pagamento', 'Pagamentos', 'Configure as formas de pagamento aceitas', 'money-bill-wave', 'var(--menu-formas-pagamento)'),
                createItem('/transportadoras', 'Transportadoras', 'Cadastre transportadoras e regras de entrega', 'truck-moving', 'var(--menu-transportadoras)'),
            ],
        },
        {
            key: 'catalog',
            title: 'Catálogo',
            pinned: false,
            items: [
                createItem('/produtos', 'Produtos', 'Cadastre produtos, variações, preços e estoque', 'box', 'var(--menu-produtos)'),
                createItem('/categorias', 'Categorias', 'Organize a árvore de categorias do seu catálogo', 'th-list', 'var(--menu-categorias)'),
                createItem('/marcas', 'Marcas', 'Gerencie as marcas associadas aos seus produtos', 'tags', 'var(--menu-marcas)'),
                createItem('/imagens', 'Imagens', 'Biblioteca de imagens usadas nos seus produtos', 'images', 'var(--menu-imagens)'),
            ],
        },
        {
            key: 'integration',
            title: 'Integração',
            pinned: false,
            items: [
                createItem('/canais', 'Canais', 'Conecte marketplaces e controle o que é publicado em cada um', 'sitemap', 'var(--menu-canais)'),
                createItem('/lojas', 'Lojas', 'Gerencie suas lojas e os dados de cada uma', 'store-alt', 'var(--menu-lojas)'),
            ],
        },
        {
            key: 'analysis',
            title: 'Análise',
            pinned: false,
            items: [
                createItem('/relatorios', 'Relatórios', 'Solicite relatórios sob medida e baixe os arquivos gerados', 'clipboard-list', 'var(--menu-relatorios)'),
                createItem('/auditorias', 'Auditoria', 'Histórico das alterações feitas na sua conta', 'eye', 'var(--menu-auditorias)'),
            ],
        },
        {
            key: 'system',
            title: 'Sistema',
            pinned: true,
            items: [
                createItem('/configuracoes', 'Configurações', 'Sincronização com os canais, cache e ajustes da conta', 'cogs', 'var(--menu-configuracoes)'),
                createItem('/atendimento', 'Atendimento', 'Suporte, dúvidas, sugestões e faturamento do Muven', 'comments', 'var(--menu-atendimento)'),
            ],
        },
    ]
}

export function flattenMenuSections(sections:MenuSection[]):MenuItem[] {
    return sections.reduce((items:MenuItem[], section) => items.concat(section.items), [])
}

export function activateMenuRoute(items:MenuItem[], path:string):MenuItem|null {
    let activeItem:MenuItem|null = null

    for (const item of items) {
        const isMatch = path === item.path || path.startsWith(item.basePath)

        item.active = !activeItem && isMatch

        if (item.active) {
            activeItem = item
        }
    }

    return activeItem
}
